export default {
  'report.add': '新增报备',
  'report.records': '报备记录',
  'report.project': '意向项目',
  'report.project.placeholder': '请输入意向项目',
  'report.city': '所在城市',
  'report.hospital': '查重医院',
  'report.hospital.placeholder': '请选择医院',
  'report.images': '图片',
  'report.images.placeholder': '请上传图片',
  'report.msg': '备注',
  'report.msg.placeholder': '请输入备注',
  'report.is_flow': '是否跟进',
  'report.is_flow.placeholder': '请选择跟进方式',
  'report.is_flow.no_contact': '正在铺垫',
  'report.is_flow.flow0': '立即联系',
  'report.is_flow.flow05': '下午联系',
  'report.is_flow.flow1': '明天联系',
  'report.is_flow.flow2': '2天后联系',
  'report.is_flow.flow3': '3天后联系',
  'report.is_flow.flow5': '5天后联系',
  'report.is_flow.flow7': '七天后联系',
  'report.state': '查重状态',
  'report.is_flow_text': '是否跟进',
};
